import { Schema } from '@/json';
export function getProductSchema(): object {
  return Schema.IpdcProduct;
}
